import { palette, indexed } from 'neuquant-js';
import rgb from 'color-space/rgb.js';
import xyz from 'color-space/xyz.js';
import lab from 'color-space/lab.js';

/**
 * 返回两个四维坐标间的欧几里得距离
 * @param a
 * @param b
 * @returns
 */
function euclidean_distance_squared(a, b) {
  const r = a[0] - b[0];
  const g = a[1] - b[1];

  const _b = a[2] - b[2];

  const _a = a[3] - b[3];

  return r ** 2 + g ** 2 + _b ** 2 + _a ** 2;
}
function euclidean_distance_squared_index(a, a_start, b) {
  const r = a[a_start++] - b[0];
  const g = a[a_start++] - b[1];

  const _b = a[a_start++] - b[2];

  const _a = a[a_start++] - b[3];

  return r ** 2 + g ** 2 + _b ** 2 + _a ** 2;
}
/**
 * 以数组形式返回三个数字中的最大值与最小值
 * @param param0 一个包含三个数字的数组
 * @returns [max,min]
 */

function max_min_of_three([a, b, c]) {
  if (a > b) {
    if (b > c) {
      //abc
      return [a, c];
    } else {
      if (a > c) {
        //acb
        return [a, b];
      } else {
        //cab
        return [c, b];
      }
    }
  } else {
    //a<b
    if (b > c) {
      if (c > a) {
        //bca
        return [b, a];
      } else {
        //bac
        return [b, c];
      }
    } else {
      //cba
      return [c, a];
    }
  }
}

function kmeans(data, k, attempt, thresold = 1) {
  const cluster_sum
  /*[r,g,b,a,c]*/
  = [];
  let cluster_centers = [];
  let new_cluster_centers = [];
  let iteration = 0;

  for (let i = 0; i < k; i++) {
    const start = Math.floor(Math.random() * data.length);
    cluster_centers.push(Array.from(data.slice(start, start + 4))); //随机选点

    new_cluster_centers.push(_filled_array(0, 4));
    cluster_sum.push(_filled_array(0, 5));
  }

  while (iteration < attempt) {
    //准备坐标和
    //计算每个点与中心的距离
    for (let i = 0; i < data.length;) {
      let cluster_index = 0;

      let _min_distance = euclidean_distance_squared_index(data, i, cluster_centers[0]);

      for (let j = 1; j < k; j++) {
        const distance = euclidean_distance_squared_index(data, i, cluster_centers[j]);

        if (distance < _min_distance) {
          _min_distance = distance;
          cluster_index = j;
        }
      }

      const sum = cluster_sum[cluster_index];
      sum[0] += data[i++];
      sum[1] += data[i++];
      sum[2] += data[i++];
      sum[3] += data[i++];
      sum[4]++;
    }

    let diff = 0; //重新计算中心点

    for (let i = 0; i < k; i++) {
      const rgbac = cluster_sum[i];
      const count = rgbac[4];

      if (count == 0) {
        //空类 重新选中心点
        const start = Math.floor(Math.random() * data.length);
        new_cluster_centers[i] = Array.from(data.slice(start, start + 4));
        diff += thresold;
      } else {
        const new_center = new_cluster_centers[i];

        for (let j = 0; j < 4; j++) {
          new_center[j] = rgbac[j] / count;
        }

        diff += Math.sqrt(euclidean_distance_squared(cluster_centers[i], new_cluster_centers[i]));
      }
    }

    if (diff <= thresold) {
      return {
        centroid: new_cluster_centers,
        iteration,
        fit: true,
        label: cluster_sum.map(v => v[4]),
        size: data.length
      };
    }

    const medium = cluster_centers;
    cluster_centers = new_cluster_centers;
    new_cluster_centers = medium;
    iteration++; //清空累加

    for (let i = 0; i < k; i++) {
      const sum_array = cluster_sum[i];
      sum_array[0] = 0;
      sum_array[1] = 0;
      sum_array[2] = 0;
      sum_array[3] = 0;
      sum_array[4] = 0;
    }
  }

  return {
    centroid: cluster_centers,
    iteration,
    fit: false,
    label: cluster_sum.map(v => v[4]),
    size: data.length
  };
}

function _filled_array(fillWith, count) {
  const array = [];

  for (let i = 0; i < count; i++) {
    array.push(fillWith);
  }

  return array;
}

function rgba2Rgb(data) {
  const rgb = new Uint8ClampedArray(data.length / 4 * 3);
  const len = data.length;
  let rgb_i = 0;

  for (let i = 0; i < len;) {
    for (let j = 0; j < 3; j++) {
      rgb[rgb_i++] = data[i++];
    }

    i++;
  }

  return rgb;
}
/**
 * @param samplefac Sampling factor, which can be changed to increase or decrease quality at the expense of performance. The lower the number, the higher the quality.
 * based on 'neuquant-js'
 */


function neuquant(img, k, samplefac = 1) {
  const img_rgb = rgba2Rgb(img);
  const palette$1 = palette(img_rgb, {
    netsize: k,
    samplefac
  });
  const indexed_pixel = indexed(img_rgb, palette$1);
  const pixel = [];
  const len = palette$1.length;

  for (let i = 0; i < len;) {
    pixel.push([palette$1[i++], palette$1[i++], palette$1[i++], 255]);
  }

  return {
    centroid: pixel,
    label: count(k, indexed_pixel)
  };
}

function count(k, index) {
  const counts = new Array(k).fill(0);

  for (const i of index) {
    counts[i]++;
  }

  return counts;
}

function _prepare2DContext(width, height) {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d'); //contextType 是存在的

  canvas.height = height;
  canvas.width = width;
  return ctx;
}
/**
 * Use OffscreenCanvas
 */


function _prepare2DContextAsync(width, height) {
  const canvas = new OffscreenCanvas(width, height);
  const ctx = canvas.getContext('2d');
  return ctx;
}
/**
 * a Promise resolved when <img> is loaded
 * @param imgElement
 * @returns Event, undefined when Image is already loaded
 */


function awaitImage(imgElement) {
  return new Promise((resolve, reject) => {
    if (imgElement.complete) {
      resolve();
    } else {
      imgElement.addEventListener('load', e => {
        resolve(e);
      });
      imgElement.addEventListener('error', reason => {
        reject(reason);
      });
    }
  });
}
const readImage = _readImage.bind(undefined, _prepare2DContext);
/**
 * read image using OffscreenCanvas
 */

const readImageOffscreen = _readImage.bind(undefined, _prepare2DContextAsync);

function _readImage(prepareCtx, imgSource) {
  const {
    naturalWidth,
    naturalHeight
  } = imgSource;
  const ctx = prepareCtx(naturalWidth, naturalHeight);
  ctx.drawImage(imgSource, 0, 0, naturalWidth, naturalHeight);
  return ctx.getImageData(0, 0, naturalWidth, naturalHeight);
}
/**
 * 降采样后读取图片
 * @param imgSource
 * @param maxSample
 * @returns
 */


const readImageDownsampling = _readImageDownsampling.bind(undefined, _prepare2DContext);
const readImageDownsamplingOffscreen = _readImageDownsampling.bind(undefined, _prepare2DContextAsync);

function _readImageDownsampling(prepareCtx, imgSource, maxSample) {
  const {
    naturalWidth: width,
    naturalHeight: height
  } = imgSource;
  const scale = width * height / maxSample;

  if (scale > 1) {
    const n_width = width / Math.sqrt(scale);
    const n_height = height / Math.sqrt(scale);
    const ctx = prepareCtx(n_width, n_height);
    ctx.drawImage(imgSource, 0, 0, n_width, n_height);
    return ctx.getImageData(0, 0, n_width, n_height);
  } else {
    const ctx = prepareCtx(width, height);
    ctx.drawImage(imgSource, 0, 0);
    return ctx.getImageData(0, 0, width, height);
  }
}

function normalizeRGBA(rgba) {
  return rgba.map(v => v / 255);
}
function rgbaToHSLA(rgba) {
  let h, s; //@ts-ignore

  const [max, min] = max_min_of_three(rgba);
  const diff = max - min;
  const light_2x = max + min; //h

  if (diff == 0) {
    h = 0;
    s = 0;
  } else {
    if (max == rgba[0]) {
      const temp_h = 60 * (rgba[1] - rgba[2]) / diff;

      if (temp_h < 0) {
        h = temp_h + 360;
      } else {
        h = temp_h;
      }
    } else if (max == rgba[1]) {
      h = 60 * (rgba[2] - rgba[0]) / diff + 120;
    } else {
      h = 60 * (rgba[0] - rgba[1]) / diff + 240;
    }

    if (light_2x == 0) {
      s = 0;
    } else if (light_2x <= 1) {
      s = diff / light_2x;
    } else {
      s = diff / (2 - light_2x);
    }
  }

  return [h, s, light_2x / 2, rgba[3]];
}
/**
 * 返回一个排序HSLA颜色的函数
 * @param sort
 * @returns
 */


const getHSLAComparer = (sort = [0, 1, 2, 3]) => (a, b) => {
  let result;

  for (const s of sort) {
    result = a[s] - b[s];

    if (result != 0) {
      return result;
    }
  } //其实是赋了值的，但是ts没猜出来
  //@ts-ignore


  return result;
};
/**
 * 将颜色转换成对应的CSS文本
 * @param param0 像素
 * @returns hsla(${h}deg,${s}%,${l}%,${a})
 */

const hslaCSSText = ([h, s, l, a]) => `hsla(${h}deg,${s * 100}%,${l * 100}%,${a})`;
/**
 * 将颜色转换成对应的CSS文本
 * @param pixel 像素
 * @returns rgba(r,g,b,a)
 */

const rgbaCSSText = pixel => `rgba(${pixel.map(v => Math.floor(v)).join(',')})`;

function convertToLab(source) {
  //CIE Lab包含浮点表示，不能使用Uint8ClampedArray
  const array = [];

  for (let i = 0; i < source.length; i += 4) {
    const pixel = source.slice(i, i + 4);
    const alpha = pixel[3];
    const pixel_rgb = pixel.slice(0, 3);
    const pixel_xyz = rgb.xyz(pixel_rgb);
    const pixel_lab = xyz.lab(pixel_xyz);
    array.push(...pixel_lab, alpha);
  }

  return array;
}
function labaToRGBA(laba) {
  const pixel_lab = laba.slice(0, 3);
  const alpha = laba[3];
  const pixel_xyz = lab.xyz(pixel_lab);
  const pixel_rgb = xyz.rgb(pixel_xyz);
  pixel_rgb.push(alpha);
  return pixel_rgb;
}

export { awaitImage, convertToLab, getHSLAComparer, hslaCSSText, kmeans, labaToRGBA, neuquant, normalizeRGBA, readImage, readImageDownsampling, readImageDownsamplingOffscreen, readImageOffscreen, rgbaCSSText, rgbaToHSLA };
//# sourceMappingURL=index.modern.js.map
